// Generated by purs version 0.15.10
import * as $foreign from "./foreign.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Fusion_EnvVars from "../Fusion.EnvVars/index.js";
import * as TypedEnv from "../TypedEnv/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var Development = /* #__PURE__ */ (function () {
    function Development() {

    };
    Development.value = new Development();
    return Development;
})();
var Production = /* #__PURE__ */ (function () {
    function Production() {

    };
    Production.value = new Production();
    return Production;
})();
var Test = /* #__PURE__ */ (function () {
    function Test() {

    };
    Test.value = new Test();
    return Test;
})();
var parseValueNodeEnv = {
    parseValue: function (v) {
        if (v === "development") {
            return new Data_Maybe.Just(Development.value);
        };
        if (v === "production") {
            return new Data_Maybe.Just(Production.value);
        };
        if (v === "test") {
            return new Data_Maybe.Just(Test.value);
        };
        return Data_Maybe.Nothing.value;
    }
};
var parseValue = /* #__PURE__ */ TypedEnv.parseValue(parseValueNodeEnv);
var genericNodeEnv_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Development.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Production.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return Test.value;
        };
        throw new Error("Failed pattern match at Fusion.EnvVars.Common (line 60, column 1 - line 60, column 34): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Development) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Production) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Test) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Fusion.EnvVars.Common (line 60, column 1 - line 60, column 34): " + [ x.constructor.name ]);
    }
};
var showNodeEnv = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericNodeEnv_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Development";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Production";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Test";
        }
    }))))
};
var eqNodeEnv = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Development && y instanceof Development) {
                return true;
            };
            if (x instanceof Production && y instanceof Production) {
                return true;
            };
            if (x instanceof Test && y instanceof Test) {
                return true;
            };
            return false;
        };
    }
};
var parseEnvVarsCommon = function (obj) {
    return {
        NODE_ENV: Data_Maybe.fromMaybe(Production.value)(bind(Foreign_Object.lookup("NODE_ENV")(obj))(parseValue))
    };
};
var envVarsCommon = /* #__PURE__ */ parseEnvVarsCommon(/* #__PURE__ */ Fusion_EnvVars.cleanEnvVarsObj($foreign.envRawCommon));
export {
    Development,
    Production,
    Test,
    envVarsCommon,
    parseValueNodeEnv,
    eqNodeEnv,
    genericNodeEnv_,
    showNodeEnv
};
